import React, { useState } from "react";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      // toast.success("Password changed successfully!");
      // Add your password change logic here
    } else {
      toast.error("New password and confirm password do not match!");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-[80vh] bg-gray-100 p-4">
      <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow border border-gray-200">
        <h2
          className="sm:text-[18px] text-[12px] font-[600] text-gray-700 mb-6"
          style={{ color: "#2d054b" }}
        >
          Change Password
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-[12px] sm:text-[14px] font-[600] text-gray-500 mb-1">
              Old Password
            </label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-[14px] focus:outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-[12px] sm:text-[14px] font-[600] text-gray-500 mb-1">
              New Password
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-[14px] focus:outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-[12px] sm:text-[14px] font-[600] text-gray-500 mb-1">
              Confirm New Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-[14px] focus:outline-none focus:ring-1 focus:ring-[#0CBB7D]"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full py-2 px-3 sm:text-[14px] text-[12px] font-[600] rounded-lg text-white hover:opacity-90"
            style={{ backgroundColor: "#0CBB7D" }}
          >
            Change
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
